import { h } from 'preact';
import VoyagesLogo from './icon/voyages-logo.svg';

const voyagesTitle = (title) => {
    const vTitle = title.replace('#voyages', '').trim()
    if (vTitle === "voyages_logo") return <VoyagesLogo />
  return vTitle
  };

  export default voyagesTitle